
import { defineComponent } from "vue";
import Calendar from "@/components/Calendar.vue"; // @ is an alias to /src
import Contact from "@/components/Contact.vue"; // @ is an alias to /src
import Bodies from "@/components/Bodies.vue"; // @ is an alias to /src
import Proposals from "@/components/Proposals.vue"; // @ is an alias to /src
import Info from "@/components/Info.vue"; // @ is an alias to /src
import Consulting from "@/components/Consulting.vue"; // @ is an alias to /src
import Menu from "@/components/Menu.vue"; // @ is an alias to /src
import Notes from "@/components/Notes.vue"; // @ is an alias to /src
import Rooms from "@/components/Rooms.vue"; // @ is an alias to /src
import Search from "@/components/Search.vue"; // @ is an alias to /src
import Tutors from "@/components/Tutors.vue"; // @ is an alias to /src
import Folder from "@/components/shared/Folder.vue"; // @ is an alias to /src
import router from "@/router";

export const SECOND = 1000;

export default defineComponent({
  name: "Home",
  components: {
    Calendar,
    Contact,
    Bodies,
    Proposals,
    Info,
    Consulting,
    Menu,
    Notes,
    Rooms,
    Search,
    Tutors,
    Folder
  },
  data: () => ({
    day: "",
    hours: "",
    minutes: "",
    focused: "",
    maximized: "",
    routeNames: {
      calendar: " / Kalender",
      contact: " / Kontakte",
      info: " / Informationen",
      search: " / Suche",
      rooms: " / Räume",
      tutors: " / Tutoren"
    } as { [k: string]: string }
  }),
  mounted() {
    this.$options.timer = window.setTimeout(this.updateDateTime, SECOND);
    setTimeout(() => (this.focused = this.$route.query["c"] as string), 1);
  },
  beforeUnmount() {
    window.clearTimeout(this.$options.timer);
  },
  // FIXME: the routing is not called in app.vue, only in (routed) components
  beforeRouteUpdate(to, from, next) {
    this.focused = to.query["c"] as string;
    next();
  },
  methods: {
    updateFocus(componentName: string): void {
      if (this.focused !== componentName) {
        router.push({ path: "", query: { c: componentName } });
        this.maximized = "";
      }
      this.focused = componentName;
    },
    updateMaximization(componentName: string): void {
      this.maximized = this.maximized ? "" : componentName;
    },
    getRoute(): string {
      const idx = this.focused?.toString();
      return this.routeNames[idx];
    },
    updateDateTime() {
      const now = new Date();
      this.day = ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."][
        now.getDay()
      ];
      this.hours = this.getZeroPad(now.getHours());
      this.minutes = this.getZeroPad(now.getMinutes());
      this.$options.timer = window.setTimeout(this.updateDateTime, SECOND);
    },
    getZeroPad(n: number): string {
      return (parseInt((n as unknown) as string, 10) >= 10 ? "" : "0") + n;
    }
  }
});
